import { Component, OnDestroy, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';
import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../common/take-until-destroy.decorator';
import { LayoutService, LtUserConfig } from '../insight';

const Cards = {
    COACHING_REP: 'coaching-rep',
    COACHING: 'coaching',
    PERFORMANCE: 'performance',
    SCORECARD: 'scorecard',
};

@Component({
    selector: '[cmpsInsightNew]',
    templateUrl: './insight-new.component.html',
})
@TakeUntilDestroy()
export class InsightNewComponent implements OnInit, OnDestroy {
    /** @private */
    _Cards = Cards;

    /** @private */
    _config: LtUserConfig;

    constructor(
        private readonly _authService: AuthService,
        private readonly _layoutService: LayoutService,
    ) {}

    ngOnInit(): void {
        this._layoutService
            .retrieveUserConfig(this._authService.user.id)
            .pipe(
                tap((config) => {
                    const cards = config?.cards ?? [];
                    cards.sort((a, b) => {
                        return (
                            (a.displayOrder ?? Number.MAX_SAFE_INTEGER) -
                            (b.displayOrder ?? Number.MAX_SAFE_INTEGER)
                        );
                    });
                    this._config = { cards };
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    ngOnDestroy(): void {}
}
